// @flow

import Request from '@insolus/request';
import Config from '@insolus/config';
import I18n from '@insolus/i18n';
import Cookies from '@insolus/cookies';

export default () => {
    Request.init({
        // eslint-disable-next-line prefer-template
        baseURL   : Config.get('location.base', '') + '/api',
        authToken : () => Cookies.get(Config.get('session.cookie')),
        lang      : () => I18n.language || Config.get('language.default', null)
    });
};
